import { createContext, ReactNode, useContext, useState } from 'react';

import { RotatingLoadingMessages } from '@components/rotating-loading-messages';
import { useMinimumDelay } from '@hooks/use-minimum-delay';

type RotatingLoadingMessageContextValue = {
  hasLoaded: boolean;
  setHasLoaded: (value: boolean) => void;
};

const RotatingLoadingMessageContext = createContext<RotatingLoadingMessageContextValue>({
  hasLoaded: false,
  setHasLoaded: () => {},
});

type RotatingLoadingMessageProviderProps = {
  title: string;
  messages: string[];
  children: ReactNode;
};

export const RotatingLoadingMessageProvider = ({
  title,
  messages,
  children,
}: RotatingLoadingMessageProviderProps) => {
  const [hasLoaded, setHasLoaded] = useState(false);
  const showSpinner = useMinimumDelay(!hasLoaded);

  return (
    <RotatingLoadingMessageContext.Provider value={{ hasLoaded, setHasLoaded }}>
      {showSpinner && <RotatingLoadingMessages title={title} messages={messages} />}
      {children}
    </RotatingLoadingMessageContext.Provider>
  );
};

export const useRotatingLoadingMessageContext = (): RotatingLoadingMessageContextValue => {
  const ctx = useContext(RotatingLoadingMessageContext);
  if (!ctx) {
    throw new Error('Missing RotatingLoadingMessageProvider');
  }

  return ctx;
};
